import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const includes = [{
  label: '📘 The Natural Veneer Blueprint™',
  value: '$97 Value'
}, {
  label: '🎁 5 Exclusive Bonuses',
  value: '$177 Value'
}];
const perks = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant access'];
export function OfferStack() {
  return <section id="offer" className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-203" data-mp="1x44uqxjkn8hb">
      <div className="mx-auto max-w-2xl" data-id="element-204" data-mp="1t6qnvcjd5csh">
        <p className="flex items-center justify-center gap-2 text-center text-[11.5px] font-extrabold uppercase tracking-[0.16em] text-brand-600" data-id="element-205" data-mp="26wu4nnzh4eaj">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="2240x6scmerur" />
          Special launch offer
        </p>
        <h2 className="mt-4 text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-207" data-mp="1ee6q6rezfxif">
          Here’s everything you’ll receive today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-brand-200 bg-white shadow-soft" data-id="element-208" data-mp="14oadhgv0y0ce">
          <ul className="divide-y divide-brand-100" data-id="element-209" data-mp="19mvdbf6d6i0b">
            {includes.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-5 py-4" data-id="element-210" data-mp="1eg7revdf36et">
                <span className="text-[15px] font-semibold leading-snug text-ink" data-id="element-211" data-mp="1jcoerncslgqu">
                  {item.label}
                </span>
                <span className="shrink-0 text-[13.5px] font-bold text-brand-600" data-id="element-212" data-mp="lskabqbcuxwx">
                  {item.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 bg-brand-50 px-5 py-4" data-id="element-213" data-mp="vmu2b6wdxu74">
              <span className="text-[13px] font-extrabold uppercase tracking-[0.1em] text-brand-700" data-id="element-214" data-mp="zqs3dn59tf2t">
                Total value
              </span>
              <span className="font-display text-xl font-bold text-brand-800 line-through decoration-[#B03636] decoration-2" data-id="element-215" data-mp="2b55k881lwu9c">
                $274
              </span>
            </li>
          </ul>

          <div className="bg-brand-800 px-5 py-8 text-center" data-id="element-216" data-mp="71b21cd311mj">
            <p className="text-[13.5px] font-semibold text-brand-200" data-id="element-217" data-mp="711bnno4ksgb">
              Today, you can get everything for just…
            </p>
            <p className="mt-2 font-display text-[62px] font-bold leading-none text-white sm:text-7xl" data-id="element-218" data-mp="g28xv7dda2u1">
              $27
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-219" data-mp="3oilxh69348qp">
              {perks.map(perk => <li key={perk} className="flex items-center justify-center gap-1.5 rounded-xl bg-white/10 px-2 py-2.5 text-[11.5px] font-bold uppercase tracking-wide text-white" data-id="element-220" data-mp="3kh8tl1pjyfmf">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gogreen-500" aria-hidden="true" data-id="element-221" data-mp="3tessi3zxzztv" />
                  {perk}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-center text-[14.5px] leading-relaxed text-brand-900/70" data-id="element-222" data-mp="30qdsanlgzm2l">
          For less than the cost of a small purchase for your practice, you’ll get a visual system
          you can reference every time you plan, build, or evaluate a resin veneer case.
        </p>

        <div className="mt-8" data-id="element-223" data-mp="177ej11xb457n">
          <CTAButton label="Get the Natural Veneer Blueprint" note="One-Time Payment of $27 USD · Instant Access · 7-Day Guarantee" data-id="element-224" data-mp="1c8ca640ao9la" />
        </div>

        <p className="mt-4 text-center text-[12.5px] font-medium text-brand-800/65" data-id="element-225" data-mp="1zwc2v9h62a2i">
          💱 Currency conversion is automatically handled based on your country.
        </p>

        <div className="mt-8" data-id="element-226" data-mp="1pzqx2lxbouxm">
          <Countdown note="🔥 Get access today at the special launch price." data-id="element-227" data-mp="1uytp95s7f6o6" />
        </div>

        <div className="mt-6" data-id="element-228" data-mp="ekttm70e636q">
          <ScarcityBar data-id="element-229" data-mp="ekka929uqua0" />
        </div>
      </div>
    </section>;
}